import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Magnetron,
  voices: {
    main: {
      description:
        "elderly commanding bass with metallic patience, Central European-flavored diction without caricature, magnetic menace, slow regal pacing, subtle steel-room resonance",
      seed: 10145,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "Be wary. No timeline exists where Magnetron yields.",
      },
      { id: "select_2", text: "The Master of Magnetism awaits." },
      { id: "select_3", text: "Magnetron will be waiting." },
      { id: "select_4", text: "I shall bide my time. But not for long." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "I call on the might of my allies to defeat my foes!",
      },
      {
        id: "spawn_2",
        text: "The future of Mutantkind lies in our hands, Emma.",
      },
      { id: "spawn_3", text: "I feel a familiar chaos in the air…" },
      { id: "spawn_4", text: "Nothing can defeat us when we stand as family!" },
      {
        id: "spawn_5",
        text: "It seems extinction is on the agenda once again. How predictable.",
      },
      {
        id: "spawn_6",
        text: "A threat against Krakoa is a threat against all Mutants. We shall not abide.",
      },
      {
        id: "spawn_7",
        text: "These Dooms still hide themselves behind metal masks? The fools…",
      },
      {
        id: "spawn_8",
        text: "Today, we fight as allies. Do not give me reason to alter that arrangement.",
      },
      {
        id: "spawn_9",
        text: "It is in the interest of all Mutants that we succeed this day. And so we shall.",
      },
      {
        id: "spawn_10",
        text: "Just as I forged a nation, I shall wield a weapon fit for a king.",
      },
      {
        id: "spawn_11",
        text: "Humans are so fond of their golden idols. But all of them shall bow to steel!",
      },
      {
        id: "spawn_12",
        text: "Charles dreamed of a safe haven for all Mutants. At last, I have made it a reality.",
      },
      {
        id: "spawn_13",
        text: "Our past was mired in loss and grief, but the future belongs to Mutantkind.",
      },
      {
        id: "spawn_14",
        text: "Perhaps we should give these humans good reason to hate and fear us after all.",
      },
      {
        id: "spawn_15",
        text: "For so long, I fought for Mutantkind's future. Our time has finally arrived.",
      },
      {
        id: "spawn_16",
        text: "I will do what it takes to protect my people, no matter the price.",
      },
      {
        id: "spawn_17",
        text: "I am not the man I used to be. I have found a greater cause.",
      },
      {
        id: "spawn_18",
        text: "Alas, we can no longer hide from the dangers that lie beyond our shores.",
      },
      {
        id: "spawn_19",
        text: "I will never allow Krakoa to suffer the same fate as Genosha.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I shall not be removed so easily." },
      { id: "respawn_2", text: "My power cannot be quelled." },
      { id: "respawn_3", text: "Mutants always rise again." },
      { id: "respawn_4", text: "Rebirth is a Mutant's greatest gift!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "For Mutantkind!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Fear Magnetron!" }],
    ability2: [
      { id: "ability2_1", text: "You shall not be harmed." },
      { id: "ability2_2", text: "You are under my protection." },
      { id: "ability2_3", text: "You need not fear." },
    ],
    ability1: [
      { id: "ability1_1", text: "You cannot hurt me." },
      { id: "ability1_2", text: "Your attacks are futile!" },
      { id: "ability1_3", text: "Insignificant gnats." },
    ],
    kill: [
      { id: "kill_1", text: "Insolent fool." },
      { id: "kill_2", text: "Exactly as I expected." },
      { id: "kill_3", text: "You should be ashamed." },
      { id: "kill_4", text: "How disappointing." },
      { id: "kill_5", text: "Was that truly your best?" },
    ],
    multikill: [
      { id: "multikill_1", text: "They fall so quickly." },
      { id: "multikill_2", text: "Barely a challenge." },
      { id: "multikill_3", text: "Three already?" },
      { id: "multikill_4", text: "Must I do everything?" },
      { id: "multikill_5", text: "This is far too easy." },
      { id: "multikill_6", text: "Yet another?" },
      { id: "multikill_7", text: "Are we done here?" },
      { id: "multikill_8", text: "No more? Good." },
      { id: "multikill_9", text: "And so it ends." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "That should be sufficient." },
      { id: "low_hp_2", text: "My strength returns…" },
    ],
    healed: [
      { id: "healed_1", text: "Ah. Much better." },
      { id: "healed_2", text: "I feel like myself again." },
      { id: "healed_3", text: "This will be helpful." },
      { id: "healed_4", text: "Exactly what I hoped to find." },
    ],
  },
} satisfies VoiceScript;

export default script;
